<div class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20"
    (click)="closeModal()">
    <div class="w-full max-w-screen-lg max-h-[90%] flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <form (ngSubmit)="saveNewAssessment()" class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto">
                <div class="w-full flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <div class="p-2 rounded-full bg-orange-100">
                            <lucide-icon [name]="icons.Mail" [size]="24" class="text-nside-orange-400"></lucide-icon>
                        </div>
                        <h2 class="oswald-font text-xl font-medium text-nside-orange-400 text-start">
                            Add New {{ assessmentSubSection.split('-')[1] || assessmentSubSection }} Assessment
                        </h2>
                    </div>
                    <button (click)="$event.preventDefault(); closeModal()" type="button">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
    
                <div class="w-full max-h-full flex flex-col gap-2 overflow-y-auto p-2">
                    <div *ngIf="currentPageRoute === 'hazard-school-ground'" class="w-full flex items-center text-start gap-2">
                        <p class="w-32 font-semibold whitespace-nowrap">Assessment Type:</p>
                        <div class="relative h-full flex flex-grow flex-col items-center">
                            <select
                                name="assessment_sub_section"
                                [(ngModel)]="assessmentSubSection"
                                (change)="onSubAssessmentChange(assessmentSubSection)"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                                <option *ngFor="let sub of assessmentByRoute[currentPageRoute]" [value]="sub">
                                    {{ sub.replace('AL-', '') }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start gap-2">    
                        <div class="w-full flex items-center text-start gap-2">
                            <p class="w-32 font-semibold whitespace-nowrap">Surveyed by:</p>
                            <div class="relative h-full flex flex-grow flex-col items-center">
                                <select 
                                    name="contact_id"
                                    [(ngModel)]="selectedContactId"
                                    (change)="onContactChange(selectedContactId)"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                >
                                    <option *ngFor="let contact of contactsList" [value]="contact.id">
                                        {{ contact.name }} - {{ contact.email }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div *ngIf="currentPageRoute == 'hazard-classroom'" class="w-full flex items-center text-start gap-2">
                            <p class="font-semibold">Room:</p>
                            <div class="relative h-full flex flex-grow flex-col items-center">
                                <input 
                                    type="text" 
                                    name="room_number" 
                                    [(ngModel)]="room_number"
                                    #room_numberRef="ngModel"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                    placeholder="E.g. 101A" required/>
                                <div 
                                    class="w-full text-start italic text-xs text-red-500"
                                    *ngIf="room_numberRef.invalid && room_numberRef.touched"
                                >
                                    This field is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full h-full text-start overflow-y-auto p-2">
                        <div class="w-full" *ngIf="assessmentSubSection && sectionForms[assessmentSubSection]">
                            <div *ngFor="let field of formSectionFields[assessmentSubSection]">
                                <div class="flex items-center mb-4">
                                    <input  
                                        type="checkbox"
                                        [(ngModel)]="sectionForms[assessmentSubSection].formData[field]"
                                        [name]="assessmentSubSection + '_' + field"
                                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2">
                                    <label for="default-checkbox" class="ms-2">{{ field }}</label>
                                </div>
                            </div>
                        </div>
                    
                        <!-- COMMENTS -->
                        <div class="w-full mt-4 text-start" *ngIf="assessmentSubSection && sectionForms[assessmentSubSection]">
                            <label class="w-full font-medium">Please provide any comments below:</label>
                            <textarea 
                                [(ngModel)]="sectionForms[assessmentSubSection].formData['comments']"
                                rows="4"
                                [name]="assessmentSubSection + '_comments'"
                                class="w-full text-sm border rounded-md p-2 mt-1"></textarea>
                        </div>
                    </div>
        
                    <div class="w-full flex items-center justify-end gap-3">
                        <button class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                            (click)="$event.preventDefault(); closeModal();">
                            Close
                        </button>
                        <button type="submit"
                            class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                            [ngClass]="{
                                'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !assessmentSubSection,
                                'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': assessmentSubSection
                            }" 
                            [disabled]="!assessmentSubSection"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
        
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>